import React, { lazy, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Grid from '@material-ui/core/Grid';

import ActionBar from './ActionBar';
import iconMapping from '../../helpers/IconMapping';

import useStyles from '../../styles/TabFactoryStyles';

function importView(element) {
  return lazy(() => import(`../../views/${element}`).catch(() => import('../shared/NullElement')));
}

function NewTabFactory({ slice }) {
  const dispatch = useDispatch();
  const tab = useSelector(slice.selectors.selectActiveTab);
  const tabs = useSelector(slice.selectors.selectTabs);
  const tabProps = useSelector(slice.selectors.selectProps);
  const classes = useStyles();

  function handleTabChange(evt, tabIndex) {
    dispatch(slice.actions.setTab({ label: tabs[tabIndex].label }));
  }

  function renderView() {
    const View = importView(tab.component);
    return <View key={tab.label} {...tabProps} {...tab.props} />;
  }

  return (
    <div className={classes.root}>
      <Grid container justify="space-between" alignItems="baseline">
        <Grid item>
          <AppBar className={classes.appbar} position="static">
            <Tabs
              className={classes.tabs}
              value={tab.index}
              onChange={handleTabChange}
              indicatorcolor="primary">
              {tabs.map((tab) => {
                const Icon = iconMapping[tab.icon];
                return (
                  <Tab
                    data-cy="tab"
                    className={classes.tab}
                    key={tab.index}
                    label={tab.label}
                    icon={<Icon />}
                  />
                );
              })}
            </Tabs>
          </AppBar>
        </Grid>

        <Grid item classes={{ root: classes.tabbar }}>
          <ActionBar slice={slice} />
        </Grid>
      </Grid>
      <div className={classes.container}>
        <Suspense fallback={<></>}>{renderView()}</Suspense>
      </div>
    </div>
  );
}

export default NewTabFactory;
